"use client";
import {ModuleReadGuard} from "@/components/shared";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useNeoContext} from "@/context/neo/neo.context";
import {DriversTableConfig} from "@/data/drivers/table.config";
import {getTableConfigWithAccess} from "@/libs/helper";
import {NextPage} from "next/types";

export const Drivers: NextPage = function () {
  //const data = DriversTableConfig;
  const {roleAccess} = useNeoContext();
  const data = getTableConfigWithAccess(
    roleAccess,
    DriversTableConfig,
    "MC004"
  );

  return (
    <ModuleReadGuard moduleCode="MC004">
      <div className="flex min-h-[calc(100vh-63px)] w-full flex-col px-5 py-5">
        {/* <div className="mb-4 flex-row px-3">
          <NeoHeader message="Drivers"></NeoHeader>
        </div> */}
        <div className="flex-row">
          {/* <NeoTable table={data.table}></NeoTable> */}
          <NeoAGgrid table={data.table}></NeoAGgrid>
        </div>
      </div>
    </ModuleReadGuard>
  );
};
